module.exports = __webpack_public_path__ + "static/media/eye-close.2eccfb85.svg";